import React from 'react';
import './CanucksLive_4.scss';

export default class CanucksLive_4 extends React.Component {
  render() {
    return (
      <div className="canucksLive_4">
        <a id="ad-container" href="#" target="_blank" className="container ad-size-300x250 loaded">
          <div className="adContent">
            <div className="copy-content">
              <div className="game-info">
                <span className="team-top">Canucks</span> <span className="vs">VS</span><br/>
                <span className="team-bottom">Coyotes</span><br/>
                <span className="date">Wed.Jan.04</span>
              </div>
              <div className="ticket-info">
                <div className="ticket-price">
                  <span className="spinner hide">
                    <img src="https://fanserv-media.s3.amazonaws.com/client/canucks/shared/spinner.svg"/>
                  </span>
                  <span className="ticket-from">
                    <span className="ticket-label">Tickets From</span>
                    <span className="dollar-sign">$</span>
                    <span className="dollar-price">56</span>
                  </span>
                  <span className="available-msg hide">
                    Limited Tickets<br /> Available
                  </span>
                </div>
              </div>
            </div>
            <div className="type-texture"></div>
            <div className="cta-button">Find Tickets</div>
            <div className="motion-content">
              <div className="player-frame player-background"></div>
              <div className="player-frame player-foreground"></div>
              <div className="texture"></div>
            </div>
          </div>
        </a>
      </div>
    )
  }
}
